import {ColorSchemeType, getColorsFromScheme} from 'platform/components';
import {Box} from 'platform/foundation';

interface CustomNoticeColorDotProps {
  color: ColorSchemeType;
}

export function CustomNoticeColorDot(props: CustomNoticeColorDotProps) {
  const {backgroundColor} = getColorsFromScheme(props.color);

  return <Box width={4} height={4} backgroundColor={backgroundColor} borderRadius="circular" />;
}
